import SideDish from '@components/offer/models/SideDish';
import { Box, Checkbox, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import SideDishBaseButton from './SideDishBaseButton';
import SideDishAmount from './SideDishAmount';

interface SideDishListItemProps {
    sideDish: SideDish;
    onClick: (sideDish: SideDish) => void
}

const SideDishListItem: React.FC<SideDishListItemProps> = observer(({ sideDish, onClick }) => {
    var isSelected = sideDish.isSelected;
    return (
        <SideDishBaseButton sideDish={sideDish} onClick={() => onClick(sideDish)}>
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                <Typography ml={0.5}>{sideDish.name}</Typography>
                <SideDishAmount sideDish={sideDish} />
            </Box>
        </SideDishBaseButton>
    )
})

export default SideDishListItem;